import ViewPeopleGroup from './ViewPeopleGroup';

export default ViewPeopleGroup;
